package com.milta.core.localization

/**
 * Strings specific to the web dashboard's "Tournées du jour" screen (MIL-48, DOM-06 — Supervision).
 * Deliberately separate from [RouteStrings] (mobile Gestionnaire dashboard), same convention as
 * [WebImportRouteStrings] (MIL-50) — but most of the screen's wording (tab labels "Aujourd'hui"/
 * "Demain", route status pills, "Démarré/Terminé à HH:mm", "X/Y livraisons") is reused as-is from
 * [RouteStrings] rather than duplicated here, since it mirrors the mobile Gestionnaire dashboard's
 * exact vocabulary (see [com.milta.web.WebDashboardContent]). Only what's genuinely new/different to
 * this web screen lives in this file.
 */
data class WebDashboardStrings(
    /** Manual "Rafraîchir" action — no auto-refresh/polling (explicit PO decision, see
     * [com.milta.feature.route.presentation.WebDashboardViewModel]). */
    val refreshButtonLabel: String,
    /** Section title above [com.milta.feature.route.presentation.WebDashboardState.expandedStops]. */
    val expandedStopsTitle: String,
    /** "○ En attente" — a stop still [com.milta.feature.route.domain.entity.DeliveryStatus.Pending]
     * behind the active one ([com.milta.feature.route.presentation.WebDashboardStopDisplayStatus.Waiting]).
     * Deliberately NOT [RouteStrings.stopStatusUpcomingLabel] ("À venir"): that key is already used by
     * the driver-side [com.milta.feature.route.presentation.StopDetailScreen] with a different sense
     * ("next stop in my own route") — a dedicated key here avoids silently changing that mobile wording.
     */
    val stopStatusWaitingLabel: String,
    /** "✗ Non livré" — a stop left [com.milta.feature.route.domain.entity.DeliveryStatus.Failed]
     * ([com.milta.feature.route.presentation.WebDashboardStopDisplayStatus.Failed]). Deliberately its
     * own key, distinct from both [RouteStrings.stopStatusFailedLabel] ("Échec", driver-side) and
     * [RouteStrings.failedDeliveryTag] ("Échec de livraison", Gestionnaire mobile route detail): the
     * MIL-48 mockup wording is "Non livré", not identical to either existing mobile label.
     */
    val stopStatusFailedLabel: String,
)
